import styled from 'styled-components'
import {
	vanilla,
	orange,
	gold,
	blackOrange,
	black,
	textMuted,
	mutedGrey,
	white,
	surface2,
	border2,
} from '@/theme/colors'
import { radii, media, motion } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { dashedSlot } from '@/theme/recipes'

/** The shared form kit (Field + Button primitives) — one copy for every modal. */
export { Button, ButtonGroup, FormGroup, FormInput, FormLabel } from '@pages/Itinerary/AddEventModal/FormComponents.styles'
import { FieldError } from '@components/Field'

/** Spaces the Auto / Manual mode switch from the form below it. */
export const ModeSwitch = styled.div`
    margin-bottom: 20px;
`


export const LegsSummary = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
`

export const LegsSummaryTitle = styled.div`
    ${text.eyebrow}
    color: ${gold};
    margin-bottom: 4px;
`

export const LegSummaryRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 12px;
    background: ${vanilla};
    border-radius: ${radii.small};
`

export const LegSummaryText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`

export const LegSummaryCode = styled.span`
    font-size: ${fontSizes.caption};
    font-weight: 700;
    color: ${black};
`

export const LegSummaryRoute = styled.span`
    font-size: ${fontSizes.micro};
    color: ${blackOrange};
`

export const LegSummaryTime = styled.span`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
`

export const AddAnotherLegButton = styled.button`
	${dashedSlot}
	color: ${gold};
`

export const ManualFallbackNotice = styled.div`
    padding: 12px 16px;
    background: ${gold}1f;
    border: 1px solid ${orange}40;
    border-radius: ${radii.small};
    font-size: ${fontSizes.caption};
    color: ${blackOrange};
    margin-bottom: 16px;
    line-height: ${leading.body};
`

export const FormDescription = styled.p`
    font-size: ${fontSizes.micro};
    color: ${mutedGrey};
    margin: -4px 0 8px;
`

export const FieldRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${media.phone} {
        grid-template-columns: 1fr;
    }
`

export const PassengersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
`

export const PassengerRowStyled = styled.div<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    border-radius: ${radii.small};
    cursor: pointer;
    transition: background ${motion.fast};
    background: ${({ $isSelected }) => ($isSelected ? `${gold}1f` : 'transparent')};

    &:hover {
        background: ${({ $isSelected }) => ($isSelected ? `${gold}1f` : surface2)};
    }
`

export const PassengerCheckbox = styled.div<{ $checked: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: ${radii.tiny};
    border: 2px solid ${({ $checked }) => ($checked ? orange : border2)};
    background: ${({ $checked }) => ($checked ? orange : white)};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all ${motion.fast};

    &::after {
        content: '${({ $checked }) => ($checked ? '\\2713' : '')}';
        color: ${white};
        font-size: ${fontSizes.micro};
        font-weight: 700;
    }
`


export const PassengerName = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${black};
    flex: 1;
`

export const SummaryBox = styled.div`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    margin-top: 8px;
    padding: 8px 12px;
    background: ${surface2};
    border-radius: ${radii.small};
`

export const ErrorText = styled(FieldError)``
